import { BaseRestRepository } from './baseRestRepository';

const LEASES_URL = '/api/leases';

export class LeaseRentalInsuranceRepository extends BaseRestRepository {
  public async getAll(leaseId: string): Promise<MagicDoor.Api.LeaseRentersInsurancesDto> {
    const url = `${LEASES_URL}/${leaseId}/rental-insurance`;
    const response = await this.fetchWithAuth(url, {
      method: 'GET',
    });
    return this.getJsonResponse(response);
  }

  public async create(
    leaseId: string,
    payload: MagicDoor.Api.CreateLeaseRentersInsuranceDto
  ): Promise<MagicDoor.Api.LeaseRentersInsuranceDto> {
    const url = `${LEASES_URL}/${leaseId}/rental-insurance`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }

  public async update(
    leaseId: string,
    insuranceId: string,
    payload: MagicDoor.Api.UpdateLeaseRentersInsuranceDto
  ): Promise<MagicDoor.Api.LeaseRentersInsuranceDto> {
    const url = `${LEASES_URL}/${leaseId}/rental-insurance/${insuranceId}`;
    const response = await this.fetchWithAuth(url, {
      method: 'PUT',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }

  public async delete(leaseId: string, insuranceId: string): Promise<void> {
    const url = `${LEASES_URL}/${leaseId}/rental-insurance/${insuranceId}`;
    await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
  }
}

export const leaseRentalInsuranceRepository = new LeaseRentalInsuranceRepository();
